export function lineOfFireSlotFactory() {
    let lineOfFireSlot = [];
    for (let i = 0; i < 6; i++) {
        lineOfFireSlot.push({
            isTargeted: false,
            protectionTurns: 0,
            isProtected(){
                return this.protectionTurns > 0
            },
        })
    }

    return lineOfFireSlot;
}